
//Copyright (c) 2022 Panshak Solomon

import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import SnackbarProvider from 'react-simple-snackbar'
import Home from './components/Home/Home';
import Invoice from './components/Invoice/Invoice';
import Invoices from './components/Invoices/Invoices';
import InvoiceDetails from './components/InvoiceDetails/InvoiceDetails'
import ClientList from './components/Clients/ClientList'
import SupplierList from './components/Suppliers/SuppliersList'
import NavBar from './components/NavBar/NavBar';
import Login from './components/Login/Login'
import Dashboard from './components/Dashboard/Dashboard';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Settings from './components/Settings/Settings';
import Forgot from './components/Password/Forgot'
import Reset from './components/Password/Reset'
import Calendar from './components/Meetings/Calendar'
import ItemsList from './components/Items/ItemsList';
import MeetingForm from './components/Meetings/MeetingForm';
import Meetings from './components/Meetings/Meetings';
import AdminLogin from'./admin/adminLogin/adminLogin';
import AdminDashboard from './admin/adminDashboard';
import AdminProfiles from './admin/adminProfiles';
import Stats from './admin/stats';
import UserStats from './admin/userStats';
import PrivacyPolicy from './components/PrivacyPolicy';
import TodayBookings from './components/TodayBookings/TodayBookings';
import Statement from './admin/adminLogin/Statement';

// import { requestFirebaseNotificationPermission } from './firebaseInit'

// import AdminOrders from './admin/adminOrders';
function App() {

  const user = JSON.parse(localStorage.getItem('profile'))
// requestFirebaseNotificationPermission()
//   .then((firebaseToken) => {
//     // eslint-disable-next-line no-console
//     console.log(firebaseToken);
//   })
//   .catch((err) => {
//     return err;
//   });
  return (
    <div>
      <BrowserRouter>
      <SnackbarProvider>
      {user&& <NavBar />}
   
      <Header />
        <Switch>
        <Route path="/login" exact component={Login} />
        <Route path="/forgot" exact component={Forgot} />
        <Route path="/reset/:token" exact component={Reset} />

      
         <Route path="/" exact component={Invoices} />
         { user && <Route path="/invoice" exact component={Invoice} />}
         { user && <Route path="/edit/invoice/:id" exact component={Invoice} />}
         { user && <Route path="/invoice/:id" exact component={InvoiceDetails} />}
         { user && <Route path="/invoices" exact component={Invoices} />}
          
         { user && <Route path="/admin" exact component={AdminLogin} />}
        { user && <Route path="/settings" exact component={Settings} />}
         { user && <Route path="/dashboard" exact component={Dashboard} />}
         { user && <Route path="/adminDashboard" exact component={AdminDashboard} />}
         { user && <Route path="/adminProfiles" exact component={AdminProfiles} />}
        
        { user && <Route path="/stats/:invoiceId" exact component={Stats} />}
         
        { user && <Route path="/userStats/:userId" exact component={UserStats} />}
         { user && <Route path="/meetings" exact component={Meetings} />}

         { user && <Route path="/customers" exact component={ClientList} />}
         { user && <Route path="/suppliers" exact component={SupplierList} />}
         { user && <Route path="/statement" exact component={Statement} />}
         { user  &&<Route path="/ItemsList" exact component={ItemsList} />}
        <Route path="/Webview/PrivacyPolicy" exact component={PrivacyPolicy} />
         { user && <Redirect exact from="/new-invoice" to="/invoice" />}
         <Route path="/TodayBookings" exact component={TodayBookings} />
         
        </Switch>
        {user &&  <Footer />}
        </SnackbarProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
